export type OverridePrimaryButtonKind = 'saving' | 'apply_bulk' | 'save';

export function overrideSectionPrimaryButtonKind(opts: {
  isSaving: boolean;
  bulkLineCount: number;
}): OverridePrimaryButtonKind {
  if (opts.isSaving) return 'saving';
  if (opts.bulkLineCount > 1) return 'apply_bulk';
  return 'save';
}
